/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillCashtags} from '../api'

export const useMutationBackfillCashtags = createReactQueryMutationHook('backfillCashtags', backfillCashtags)
